<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center mb-6">
    Registrar Documento: {{ documentoData.nombre }}
  </h2>
  <div class="flex justify-between items-center mb-4">
    <button
      type="button"
      (click)="goBack()"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
    >
      Volver
    </button>
  </div>

  <!-- Contenedor de dos columnas para la información del documento y el aviso -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
    <!-- Columna 1: Información del documento -->
    <div class="center">
      <div class="p-8 border border-gray-300 rounded bg-gray-100">
        <!-- <p><strong>Nombre del Documento:</strong> {{ documentoData.nombre }}</p> -->
        <p>
          <strong>Unidad Funcional:</strong> {{ documentoData.unidadFuncional }}
        </p>
        <p><strong>Oficina:</strong> {{ documentoData.oficina }}</p>
        <p>
          <strong>Descripción:</strong>
          {{ documentoData?.descripcion || "No disponible" }}
        </p>
        <p>
          <strong>Tipo de documento:</strong> {{ documentoData.tipo_documento }}
        </p>
        <p>
          <strong>Fecha de Inicio:</strong> {{ documentoData.fecha_inicio }}
        </p>
        <p><strong>Fecha de Fin:</strong> {{ documentoData.fecha_fin }}</p>
        <p>
          <strong>Link de formato:</strong>
          <a
            *ngIf="documentoData?.link_formato"
            [href]="documentoData.link_formato"
            target="_blank"
            class="text-blue-500 hover:text-blue-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            rel="noopener noreferrer"
          >
            Visualizar Formato
          </a>
          <span *ngIf="!documentoData?.link_formato">No disponible</span>
        </p>
      </div>
    </div>

    <!-- Columna 2: Aviso importante -->
    <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
      <h2 class="text-xl font-semibold text-yellow-700 mb-4">
        ⚠️ Información Importante
      </h2>

      <!-- Lista de instrucciones -->
      <div class="space-y-3">
        <!-- Instrucción 1: Descargar formato sugerido (si está disponible) -->
        <div class="bg-yellow-100 p-3 rounded-lg">
          <p class="text-base font-medium text-yellow-800">
            •
            <strong>Descargue el formato sugerido (si está disponible).</strong>
            Si se ha proporcionado un formato, asegúrese de utilizarlo y
            verificar que los datos estén correctamente alineados con las
            especificaciones.
          </p>
        </div>

        <!-- Instrucción 2: Verificar formato del archivo -->
        <div class="bg-yellow-100 p-3 rounded-lg">
          <p class="text-base font-medium text-yellow-800">
            • <strong>Verifique el formato del archivo.</strong>
            Asegúrese de que el archivo esté en el formato requerido (PDF,
            Excel, Word, etc.). Revise las especificaciones proporcionadas para
            confirmar.
          </p>
        </div>

        <!-- Instrucción 3: Verificar contenido del archivo -->
        <div class="bg-yellow-100 p-3 rounded-lg">
          <p class="text-base font-medium text-yellow-800">
            • <strong>Revise el contenido del archivo antes de subirlo.</strong>
            Confirme que toda la información sea correcta y esté completa. Una
            vez enviado, no podrá realizar cambios hasta que el documento sea
            revisado.
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Sección de subida de archivos (debajo de las dos columnas) -->
  <form
    (ngSubmit)="saveDocumentoCargado()"
    class="bg-white border border-gray-200 rounded-lg shadow-sm p-6"
  >
    <h3 class="text-lg font-medium text-gray-900 mb-4">Cargar Documento</h3>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      <div>
        <label for="archivo" class="block text-sm font-medium mb-1"
          >Subir Archivo:</label
        >
        <input
          type="file"
          id="archivo"
          (change)="onFileSelected($event)"
          class="border border-gray-300 rounded py-2 px-4 w-full"
          required
        />
        <p *ngIf="errorArchivo" class="text-red-500 text-sm mt-2">
          {{ errorArchivo }}
        </p>
      </div>

      <div>
        <label for="linkArchivo" class="block text-sm font-medium mb-1"
          >Link del Archivo:</label
        >
        <input
          type="url"
          id="linkArchivo"
          [(ngModel)]="linkArchivo"
          name="linkArchivo"
          class="border border-gray-300 rounded py-2 px-4 w-full"
          [readonly]="true"
          placeholder="Se generará automáticamente"
        />
      </div>
    </div>

    <div class="flex justify-end items-center mt-6">
      <button
        type="submit"
        [disabled]="!linkArchivo"
        class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      >
        Guardar
      </button>
    </div>
  </form>
</div>
